/** Just Brilliant commerce coordination: cart controls and responsive cart count. */
(function () {
  'use strict';
  if (window.jbCommerceReady) return;
  window.jbCommerceReady = true;
  let countObserver;

  function syncCartCounts() {
    const source = document.querySelector('#cart-drawer-toggle .thb-item-count');
    if (!source) return;

    const empty = !source.querySelector('svg') && !(parseInt(source.textContent, 10) > 0);
    document.querySelectorAll('[data-cart-drawer-toggle], #cart-drawer-toggle').forEach(button => button.setAttribute('data-jb-cart-empty', String(empty)));

    document.querySelectorAll('[data-cart-drawer-toggle] .thb-item-count').forEach(function (count) {
      if (count === source) return;
      count.innerHTML = source.innerHTML;
    });
  }

  function bindCount() {
    countObserver?.disconnect();
    syncCartCounts();
    const source = document.querySelector('#cart-drawer-toggle .thb-item-count');
    if (source && window.MutationObserver) {
      countObserver = new MutationObserver(syncCartCounts);
      countObserver.observe(source, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

  }

  function init() {
    bindCount();
    document.addEventListener('shopify:section:load', bindCount);
    document.addEventListener('cart:rendered', syncCartCounts);
    document.addEventListener('line-item:change:end', syncCartCounts);
    document.addEventListener('cart:item-added', syncCartCounts);
    document.addEventListener('cart:refresh', syncCartCounts);
    // Restored history pages contain the cart markup from before the purchase.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
